import { APIS } from '@/constants';
import axios from 'axios';

const roleApi = {
  /**
   *
   * @param {String} token
   * @param {Object} data
   * @returns {AxiosPromise}
   */
  requestUpdate(token, data) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: '/update',
      method: 'put',
      baseURL: APIS.BASE_URL.ROLE,
      headers,
      data,
    });
  },
};

export default roleApi;
